import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export function useGoToHome() {
  const navigate = useNavigate();
  const { pathname, hash } = useLocation();

  return useCallback(
    (event) => {
      event.preventDefault();

      if (pathname === '/' && !hash) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      navigate('/');
    },
    [navigate, pathname, hash],
  );
}
